import * as React from 'react';

export const TRANSITION_DURATION: number = 150;

export const useNotification = () => {
  const [isVisible, setIsVisible] = React.useState<boolean>(true);
  const toggle = () => setIsVisible(!isVisible);
  const closeNotification = () => setIsVisible(false);

  return {
    isVisible,
    toggle,
    closeNotification,
  };
};
